// /src/components/menuData.js
// Full menu data with everything from your previous code
// Exporting as default so we can do "import menuData from './menuData'"

const menuData = {
  Friday: {
   
    sections: [
      {
        title: 'Appetizers',
        items: [
          { name: 'Salada', description: 'House Salad', price: 5.0 },
        ],
      },
      {
        title: 'Fish & Seafood',
        items: [
          { name: 'Lula Grelhada', description: 'Grilled Squid', price: 25.0 },
          {
            name: 'Bacalhau à Braga',
            description: 'Pan fried Cod Fish with Potatoes, Bell-Peppers, and Onions',
            price: 30.0,
          },
        ],
      },
      {
        title: 'Meats & Poultry',
        items: [
          {
            name: 'Frango de Churrasco',
            description: 'BBQ Chicken',
            price: 20.0,
          },
          {
            name: 'Bifanas',
            description: 'Marinated Pork Sandwich',
            price: 6.0,
          },
        ],
      },
      {
        title: 'Sides',
        items: [
          { name: 'Batata Frita', description: 'French Fries', price: 4.0 },
        ],
      },
    ],
  },
  Saturday: {
   
    sections: [
      {
        title: 'Soups',
        items: [
          { name: 'Sopa de Caldo Verde', description: 'Green Colard Soup', price: 5.0 },
        ],
      },
      {
        title: 'Appetizers',
        items: [
          { name: 'Salada', description: 'House Salad', price: 5.0 },
        ],
      },
      {
        title: 'Fish & Seafood',
        items: [
          {
            name: 'Polvo Assado no Forno',
            description: 'Oven-Baked Octopus',
            price: 35.0,
          },
          {
            name: 'Bacalhau à Braga',
            description: 'Pan Fried Cod Fish with Potatoes, Bell peppers, and Onions',
            price: 30.0,
          },
          {
            name: 'Lulas Grelhadas',
            description: 'Grilled Squid with lemon and herbs',
            price: 30.0,
          },
        ],
      },
      {
        title: 'Meats & Poultry',
        items: [
          {
            name: 'Frango de Churrasco',
            description: 'BBQ Chicken',
            price: 20.0,
          },
          {
            name: 'Bifanas',
            description: 'Marinated Pork Sandwich',
            price: 6.0,
          },
          { name: 'Dobrada', description: 'Tripe Stew', price: 20.0 },
        ],
      },
      {
        title: 'Sides',
        items: [
          { name: 'Batata Frita', description: 'French Fries', price: 4.0 },
        ],
      },
    ],
  },
  Sunday: {
   
    sections: [
      {
        title: 'Appetizers',
        items: [
          { name: 'Salada', description: 'House Salad', price: 5.0 },
        ],
      },
      {
        title: 'Fish & Seafood',
        items: [
          {
            name: 'Polvo Assado no Forno',
            description: 'Oven-Baked Octopus',
            price: 35.0,
          },
          {
            name: 'Bacalhau à Brás',
            description: 'Shredded Cod with Potatoes, Eggs, and Onions',
            price: 25.0,
          },
        ],
      },
      {
        title: 'Meats & Poultry',
        items: [
          {
            name: 'Mão de Vaca',
            description: 'Cow’s Trotters Stew',
            price: 20.0,
          },
          {
            name: 'Frango de Churrasco',
            description: 'BBQ Chicken',
            price: 20.0,
          },
          {
            name: 'Bifanas',
            description: 'Marinated Pork Sandwich',
            price: 6.0,
          },
        ],
      },
      {
        title: 'Sides',
        items: [
          { name: 'Batata Frita', description: 'French Fries', price: 4.0 },
        ],
      },
    ],
  },
};

export default menuData;
